import {Dispatch, SetStateAction} from 'react';

export enum NotFoundVariantEnum {
	UF = 'UF',
	CITY = 'CITY',
	DISTRICT = 'DISTRICT',
}

export type NotFoundDialogProps = {
	variant: NotFoundVariantEnum;
	handleGuideNav: () => void;
	handleCallChatRoom: () => void;
	open: boolean;
	setOpen: Dispatch<SetStateAction<boolean>>;
	isLoading?: boolean;
	isDisabled?: boolean;
};
